import { Accordion } from '@scale/scaleui';
import { EditableChatMessage } from '../EditableChatMessage';
import { Message } from '@scale/shared/types/chat-completion';

export function ExpandableMessageHistory({ messages }: { messages: Message[] }) {
  const head = messages.slice(0, messages.length - 1);
  const tail = messages[messages.length - 1];
  if (messages.length === 0) {
    return null;
  } else if (head.length === 0) {
    return <EditableChatMessage message={tail} />;
  } else {
    return (
      <div>
        <Accordion
          header={`Previous messages (${head.length})`}
          target={
            <div className="flex flex-col gap-2">
              {head.map((message, index) => (
                <EditableChatMessage key={index} message={message} />
              ))}
            </div>
          }
        />
        <div className="my-4">
          <EditableChatMessage message={tail} />
        </div>
      </div>
    );
  }
}
